import React from 'react';
import { Box, Grid } from 'grommet';
import styled from 'styled-components';
import { StyledSpan } from 'granite-admin/core/components/Animations/SkeletonAnimation';
const HeaderBox = styled(StyledSpan)`
  width: 100%;
  height: 30px;
`;
const Cells = styled(StyledSpan)`
  border-radius: 3px;
  width: calc(100% - 5px);
  height: 15px;
`;
const SearchBox = styled(StyledSpan)`
  border-radius: 100px;
  width: calc(100% - 60%);
  height: 38px;
`;
const FilterBox = styled(StyledSpan)`
  border-radius: 2px;
  width: 40px;
  height: 38px;
`;
const RefreshBox = styled(FilterBox)`
  height: 30px;
`;
const PageSizeBox = styled(FilterBox)`
  width: 80px;
  height: 30px;
`;
const TotalRecordsBox = styled(FilterBox)`
  width: 90px;
  height: 30px;
`;
const PaginationBox = styled(FilterBox)`
  width: 120px;
  height: 30px;
`;
const TableSkeletonLoader = () => {
  return /*#__PURE__*/React.createElement(Box, {
    fill: true,
    gap: "medium",
    pad: "small"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    justify: "between",
    align: "center"
  }, /*#__PURE__*/React.createElement(FilterBox, null), /*#__PURE__*/React.createElement(SearchBox, null)), /*#__PURE__*/React.createElement(Box, {
    border: true,
    overflow: {
      horizontal: 'auto'
    }
  }, /*#__PURE__*/React.createElement(HeaderBox, null), /*#__PURE__*/React.createElement(Grid, {
    columns: {
      count: 6,
      size: 'auto'
    },
    gap: "medium",
    pad: "medium"
  }, [...Array(24).keys()].map((i, ind) => /*#__PURE__*/React.createElement(Cells, {
    key: ind + 'cell'
  })))), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    justify: "between",
    align: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    gap: "medium"
  }, /*#__PURE__*/React.createElement(RefreshBox, null), /*#__PURE__*/React.createElement(PageSizeBox, null)), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    gap: "medium"
  }, /*#__PURE__*/React.createElement(TotalRecordsBox, null), /*#__PURE__*/React.createElement(PaginationBox, null))));
};
export default TableSkeletonLoader;